<template>
  <div>
<!--    <shareHead></shareHead>-->
<!--    <div class="offset"></div>-->
    <personalDetail :isSharePage="true" :isShowBack="false" :personJoinInfo="personJoinInfo" :title="getTitle">
      <div slot="foot">
        <!--    投票数-->
        <div v-if="isVote1Page" class="voteCount dw">{{getVote1Count}} 票</div>
        <div v-if="isVote2Page" class="voteCount dw">{{getVote2Count}} 票(决赛)</div>
        <!--    脚部-->
        <div class="foot dw">
<!--          <div class="main" @click="homePage">主页</div>-->
          <div class="mid_null"></div>
          <div v-if="isVote1Page" class="voteIcon" @click="vote">投票</div>
          <div v-else-if="isVote2Page" class="voteIcon" @click="vote">投票</div>
          <div v-else class="mid_null"></div>
<!--          <div class="share" @click="sharePage">分享</div>-->
          <div class="mid_null"></div>
        </div>
      </div>
    </personalDetail>
  </div>
</template>

<script>
import {actUtil} from "../../../js/activity/util";
import {ImagePreview, Toast} from "vant";
import {activity} from "../../../js/activity/getInfo";
import personalDetail from "../item/personalDetail";
import shareHead from "./shareHead";
import {actConfig} from "../../../js/activity/actConfig";
import {userVote1, userVote2} from "../../../js/activity/vote";
import {shareWXInit, shareWXUnInit} from "../../../js/activity/share";
import {enableAppSDK, getAppLogin, getWXLogin} from "../../../network/wx/wxmp";
import {wxAccountMgr} from "../../../network/wx/wxAccountMgr";
import {baseConfig} from "../../../network/baseConfig";
import md5 from "js-md5";
import {errDailog} from "../../../js/activity/errDialog";
import {apiSys} from "../../../network/app/sys";

const wxRetState = 'ie8dflfLfiwq'
export default {
  name: "shareMPPersonalDetail",
  components:{
    personalDetail,
    shareHead,
  },
  data(){
    return {
      actID: 0,
      userId: '',
      page: '',
      personJoinInfo: {},
      userInfoId: 0,
      signed: "",
      isLogin: false,
    }
  },
  computed:{
    getBanJi(){
      return actUtil.toGradeString(this.personJoinInfo.grade)
    },
    getAge(){
      return actUtil.toAge(this.personJoinInfo.birthday)
    },
    getVote1Count(){
      return this.personJoinInfo.voteNum1
    },
    getVote2Count(){
      return this.personJoinInfo.voteNum2
    },
    isVote1Page(){
      return this.page=='vote1'
    },
    isVote2Page(){
      return this.page=='vote2'
    },
    getTitle(){
      return actConfig.getData()
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log(from, 'beforeRouteEnter');
  //   alert("测试1from:"+JSON.stringify(from))
  //   next(vm => {
  //     // vm相当于上面的this
  //     // vm.fromPage = from.path;
  //   });
  // },
  created() {
    document.documentElement.scrollTop = 0;
    console.log('shareActPersonPage create');
    //输入的参数
    console.log(this.$route.params)
    console.log(this.$route.query)

    this.page = this.$route.params.page
    this.actID = this.$route.params.actID
    this.userId = this.$route.params.userId
    this.userInfoId = this.$route.params.userInfoId
    this.signed = this.$route.params.signed
    this.isLogin = false
    // console.log("unionId:"+this.userInfoId)
    //页面查询错误提示
    if(!(this.page=='vote1'
        || this.page=='vote2'
        || this.page=='final')){
      this.$myDialog({
        logo: 'fail',
        text: '404 not find page!',
        btnOK: "确认",
        callBack: (state) => { }
      });
      return
    }

    Toast.loading({
      duration: 5000, // 持续展示 toast
      forbidClick: true,
      message: '加载中...',
    });

    //获取活动详情
    actConfig.getData().activityId = this.actID
    this.getDetail()
  },
  methods:{
    getDetail(){
      // 获取活动详情--无需token
      activity.getActDetail().then(baseInfo=>{
        console.log(baseInfo.title);
        actConfig.getData().activityTitle = baseInfo.title
        actConfig.getData().activityLogo = baseInfo.img

        //查询用户信息
        this.getCansaiVideo(this.userId)
      }).catch(err=>{
        Toast.clear()
        errDailog(this, err.code, this.getDetail)
        // this.$myDialog({
        //   logo: 'fail',
        //   text: err.msg,
        //   btnOK: "重试",
        //   btnCancel: "取消",
        //   callBack: (state)=>{
        //     console.log('获取活动详情 callback='+state)
        //     if(state){
        //       this.getDetail()
        //     }
        //   }
        // });
      }).finally(()=>{})
    },
    getCansaiVideo(userId) {
      // console.log('开始获取用户参赛视频');
      let obj = {
        userId: userId,    //搜索关键字  (string)
        shortlisted: 0,    //是否入围50名 0:不限 1:入围
      }
      //获取前50名
      activity.getCansaiVideo(obj).then(joinList => {
        // console.log('获取用户参赛视频 ok');
        // console.log(joinList.joins.length)
        if(joinList.joins.length==0){
          this.tipRetry(userId,'查不到询用户信息！')
        }else{
          this.personJoinInfo = joinList.joins[0]
        }
        shareWXUnInit()
        // this.getUserInfo(this.userInfoId)
        this.wxLogin()

        Toast.clear()
      }).catch(err => {
        Toast.clear()
        console.log('获取用户参赛视频 err' + err);
        if (err.code!=10005){
          this.tipRetry(userId,err.msg)
        }
      })
    },
    tipRetry(userId, msg){
      var that = this
      this.$myDialog({
        logo: 'fail',
        text: msg,
        btnOK: "重试",
        btnCancel: "取消",
        callBack: (state) => {
          console.log('获取用户参赛视频 callback=' + state)
          if(state){
            that.getCansaiVideo(userId)
          }
        }
      });
    },
    getUserInfo(infoId){
      wxAccountMgr.getUserInfo(infoId).then(res=>{
        let url = window.location.href
        let num = url.lastIndexOf('/')
        url = url.slice(0,num)
        //检查signed是否正确
        let signCode  = ''
        signCode += url
        signCode += res.openId
        signCode += res.unionId
        signCode += baseConfig.wechatAPIConfig.SECRET();

        // console.log("------------------------res.accessToken:"+res.accessToken)
        // alert(signCode)
        if (md5(signCode) !== this.signed) {
          this.$myDialog({
            logo: 'fail',
            text: '当前投票链接无效！',
            btnOK: "关闭",
            callBack: (state) => { }
          });
        }else{
          this.Login(res.openId, res.unionId)
        }

      }).catch(err=>{
        this.$myDialog({
          logo: 'fail',
          text: '获取用户信息失败，请刷新重试！',
          btnOK: "刷新",
          callBack: (state) => {
            if(state){
              window.location.reload()
            }
          }
        });
      })
    },
    Login2222(openId, unionId){
      //获得用户授权
      //向APP接口-获取token
      getAppLogin({'unionId': unionId, 'identifier': openId, 'accessToken': accessToken, 'platform': 'mp'} ).then(res=>{
        console.log('APP微信登录成功');
        if(res.token){
          this.isLogin = true
          enableAppSDK(res.token)
        }
      }).catch(err=>{
        this.$myDialog({
          logo: 'fail',
          text: '微信登录失败，请刷新重试！',
          btnOK: "刷新",
          callBack: (state) => {
            if(state){
              window.location.reload()
            }
          }
        });
      })
    },
    wxLogin(){
      //获得用户授权
      //向APP接口-获取token
      let url = window.location.href
      let num = url.lastIndexOf('/')
      url = url.slice(0,num)
      wxAccountMgr.getWXLoginToken(this.actID, this.userId, this.userInfoId, this.signed, url).then(res=>{
        console.log('APP微信登录成功');
        if(res.token){
          this.isLogin = true
          enableAppSDK(res.token)
        }
      }).catch(err=>{
        this.$myDialog({
          logo: 'fail',
          text: '微信登录失败，无法投票！',
          btnOK: "关闭",
          callBack: (state) => {
            if(state){
              // window.location.reload()
            }
          }
        });
      })
    },
    homePage(){
      // this.$route.params.isVote = this.isVote
      // this.$router.back()
      // this.$router.replace({name:'shareHome'})
      this.$router.replace({path: '/share/shareHome/'+actConfig.getData().activityId})
    },
    vote(){
      if(this.isLogin)
      {
        if(this.isVote1Page){
          userVote1(this, this.personJoinInfo)
        }else if(this.isVote2Page){
          userVote2(this, this.personJoinInfo)
        }
      }else{
        this.$myDialog({
          logo: 'null',
          text: "正在登录，请稍后再试！",
          btnOK: "确认",
          callBack: (state) => { }
        });
      }
    },
    sharePage(){
      this.$myDialog({
        logo: 'null',
        text: "请点击右上角“...”进行分享。",
        btnOK: "确认",
        callBack: (state) => { }
      });
    }
  }
}
</script>

<style scoped>
.offset{
  width: 100%;
  height: 130px;
  /*background-color: #ff8198;*/
}
.dw{
  width: 990px;
  margin: auto;
}
.voteCount{
  margin-bottom: 30px;
  font-size: 50px;
  line-height: 70px;
  color: #3c3d41;
  text-align: center;
}
.foot{
  position: relative;
  height: 180px;
  width: 690px;
  /*background-color: #ff5777;*/
}
.main,
.mid_null,
.share,
.voteIcon
{
  float: left;
  width: 230px;
  height: 170px;
  /*background-color: #fed554;*/
  font-size: 40px;
  text-align: center;
  line-height: 250px;
  color: #3c3d41;
  font-weight: normal;
  /*background-size: 50% 50%;*/
  background-repeat: no-repeat;
  background-position: top center;
}
.main{
  background-image: url("../../../assets/act001/home.png");
  background-size: 60px 69px;
}
.share{
  background-image: url("../../../assets/act001/share.png");
  background-size: 95px 70px;
}
.voteIcon{
  /*background-image: url("../../../assets/act001/btnVote.png");*/
  /*background-size: 160px 160px;*/
  background-color: #2b80ed;
  border-radius: 170px;
  width: 170px;
  margin-left: 30px;
  line-height: 170px;
  color: whitesmoke;
  font-weight: bolder;
}
</style>

